import PropTypes from 'prop-types';

import GenericFormContainer from '../Forms/GenericFormContainer';

import {
  validatePhoneNumber,
  lengthValidation60,
  required,
  validateEmail,
  validatePassword,
} from '../Forms/utils';

import {
  CHANGE_LOGIN_TYPE,
  COMPLETE_USER_SIGN_UP,
  RESET_PASSWORD,
  UPDATE_EMAIL_PHONE,
} from './constants';

import {
  REACT_SELECT_INPUT,
  STYLED_PASSWORD,
  STYLED_TEXT,
} from '../Forms/fieldTypes';

const ManageUserComponent = (props) => {
  const { person, actionType, form, onSubmit, initialValues, validate } = props;

  const options = [
    {
      label: 'Update email / phone',
      value: UPDATE_EMAIL_PHONE,
    },
    {
      label: 'Reset password',
      value: RESET_PASSWORD,
    },
    {
      label: 'Change login type',
      value: CHANGE_LOGIN_TYPE,
    },
    {
      label: 'Complete user sign up',
      value: COMPLETE_USER_SIGN_UP,
      isDisabled: !person?.editable,
    },
  ];

  const formData = [
    {
      label: 'Select Action',
      keyName: 'action',
      validate: [required],
      fieldType: REACT_SELECT_INPUT,
      options,
    },
    {
      label: 'Email',
      keyName: 'email',
      fieldType: STYLED_TEXT,
      validate: [validateEmail],
      disabled: !actionType || actionType === RESET_PASSWORD,
    },
    {
      label: 'Phone Number',
      keyName: 'phoneNumber',
      fieldType: STYLED_TEXT,
      validate: [validatePhoneNumber],
      disabled: !actionType || actionType === RESET_PASSWORD,
    },
    {
      label: 'Password',
      keyName: 'password',
      fieldType: STYLED_PASSWORD,
      validate: [validatePassword, lengthValidation60],
      disabled: !actionType || actionType === UPDATE_EMAIL_PHONE,
      fieldNotes:
        'Password must be at least 8 characters and include letters and numbers',
      autoComplete: 'new-password',
    },
    {
      label: 'Confirm Password',
      keyName: 'confirmPassword',
      fieldType: STYLED_PASSWORD,
      validate: [],
      disabled: !actionType || actionType === UPDATE_EMAIL_PHONE,
      autoComplete: 'new-password',
    },
  ];

  return (
    <GenericFormContainer
      form={form}
      formData={formData}
      onSubmit={onSubmit}
      initialValues={initialValues}
      validate={validate}
      title="Manage User"
      submitText="Save"
      backButton={false}
      isFullWidthForm
      canBeUpdated
      enableReinitialize
    />
  );
};

ManageUserComponent.defaultProps = {
  actionType: null,
  validate: () => {},
};

ManageUserComponent.propTypes = {
  person: PropTypes.instanceOf(Object).isRequired,
  actionType: PropTypes.string,
  form: PropTypes.string.isRequired,
  initialValues: PropTypes.instanceOf(Object).isRequired,
  onSubmit: PropTypes.func.isRequired,
  validate: PropTypes.func,
};

export default ManageUserComponent;
